module.exports = __webpack_public_path__ + "img/gaoxinqiye.47b11fbf.png";